import { createFileRoute, notFound } from "@tanstack/react-router";
import TopicDetail from "@/pages/TopicDetail";
import NotFound from "@/pages/NotFound";
import { topicExists } from "@/lib/seo/exists.functions";

export const Route = createFileRoute("/_app/topics/$slug")({
  loader: async ({ params }) => {
    const exists = await topicExists({ data: params.slug });
    if (!exists) throw notFound();
    return null;
  },
  notFoundComponent: NotFound,
  component: () => <TopicDetail />,
});
